module.exports = __webpack_public_path__ + "img/verify_status_upload.a07a66b2.svg";